import React from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import CollapsablePlugin from 'components/common/CollapsablePlugin'
import Nixi1Spinner from 'components/Nixi1Spinner'
import './styles.scss'
import usePluginTrackingHistory from './usePluginTrackingHistory'
import { getFormatedDate } from 'utils'

const PluginTrackingHistory = ({ userId }) => {
  const { isOpen, isLoading, history, onClickCollapse } = usePluginTrackingHistory({ userId })
  if (!userId) return null

  return (
    <CollapsablePlugin
      isOpen={isOpen}
      onClickCollapse={onClickCollapse}
      title={I18n.t("dashboard_navigation_history")}
      icon="icon-target-dark"
    >

      <div className='tracking-history'>
        {
          isLoading ? (
            <div className="tracking-history__loading">
              <Nixi1Spinner width='15px' height='15px' />
            </div>
          ) : null
        }
        {
          history.length > 0 ? history.map((item, index) => {
            if (!item.type) return null

            const isTrackEvent = item.type === 'track_event'

            return (
              <div className="tracking-history__item" key={index}>
                <div className='tracking-history__item--content'>
                  <div className='tracking-history__item--content--figure'>
                    {index > 0 && (
                      <div className='tracking-history__item--content--figure--line'>&nbsp;</div>
                    )}
                    <figure>
                      <img
                        src={getStaticImage(`/icons/orange-brand/${isTrackEvent ? 'icon-elipse' : 'icon-vertical-line'}.svg`)}
                        alt='icon-track'
                      />
                    </figure>
                    {index < history.length - 1 && (
                      <div className='tracking-history__item--content--figure--line'>&nbsp;</div>
                    )}
                  </div>
                  <section>
                    {isTrackEvent ? <p>{item.content}</p> : (
                      <>
                        <p>{I18n.t('dashboard_has_visited_page')}: </p>
                        <h6 className="item__info--title" title={item.title}>{item.title}</h6>
                        <a title={item.url} href={item.url} target='_blank' rel="noopener noreferrer">{item.url}</a>
                      </>
                    )}
                  </section>
                </div>
                <div className='tracking-history__item--date'>
                  <p>{getFormatedDate({ isoString: item.createdAt, withTime: false, withYear: false })}</p>
                  <p>{getFormatedDate({ isoString: item.createdAt, justTime: true, withTime: true })}</p>
                </div>
              </div>
            )
          }) : null
        }
        {
          !isLoading && history.length === 0 ?(
            <div className="tracking-history__empty">
              {I18n.t('dashboard_no_history')}
            </div>
          ) : null
        }
      </div>
    </CollapsablePlugin>
  )
}

export default PluginTrackingHistory
